import CookieStorageService from 'services/CookieStorageService';


const cookieName = 'cam4-UTM-campaigns';
const daysAvailable = 30;
const keyMapping = {
  'utm_campaign': 'utmCampaign',
  'utm_content': 'utmContent',
  'utm_medium': 'utmMedium',
  'utm_source': 'utmSource',
  'utm_term': 'utmTerm',
  'var9': 'var9',
};

class UTMTracking {
  initialize = () => {
    if (CookieStorageService.hasCookie(cookieName)) {
      return;
    }

    const cookieContent = {};
    const params = new URLSearchParams(window.location.search);

    for (const [key, value] of params.entries()) {
      const name = keyMapping[key];
      if (name) {
        cookieContent[name] = value;
      }
    }

    if (!Object.keys(cookieContent).length) {
      return;
    }

    const expires = new Date();
    expires.setDate(expires.getDate() + daysAvailable);
    const cookieOptions = { path: '/', expires };

    CookieStorageService.set(cookieName, cookieContent, cookieOptions);
  };

  extractData = () => {
    if (!CookieStorageService.hasCookie(cookieName)) {
      return null;
    }

    const data = CookieStorageService.get(cookieName);

    if (data && !Array.isArray(data) && typeof data === 'object') {
      return data;
    }

    this.resetData();

    return null;
  };

  resetData = () => {
    if (!CookieStorageService.hasCookie(cookieName)) {
      return;
    }

    CookieStorageService.remove(cookieName);
  };
}

export default new UTMTracking();
